var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-alert',{staticClass:"mt-6 mx-auto",attrs:{"max-width":"800","type":"info","text":""}},[_vm._v(_vm._s(_vm.message))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }